import { render } from "./OssConfig.vue?vue&type=template&id=efa7f8f2&scoped=true"
import script from "./OssConfig.vue?vue&type=script&lang=js"
export * from "./OssConfig.vue?vue&type=script&lang=js"

import "./OssConfig.vue?vue&type=style&index=0&id=efa7f8f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa7f8f2"]])

export default __exports__